import axios from '@src/api/axiosInstance';
import {cachedReference} from '@src/helpers/LoadingCache';
import { PaginatedResponse } from '@src/types/common';
import { Group } from '@src/types/groups';

export const fetchGroups = (): Promise<PaginatedResponse<Group>> => cachedReference('groups',async () => {
	const response = await axios.get<PaginatedResponse<Group>>('/groups/');
	return response.data;
});
